import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';
import { v4 as uuid } from 'uuid';

import { FILTERS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';
import {
  EArbitrageFilters,
  ECexPairFilters,
  EDexPairFilters,
  EGeneralFilters,
  EProjectFilters,
  ESolPairFilters,
  IFilters,
} from 'types/filters';
import { IFilterValue } from 'types/filters/common';
import { ICexPair, IDexPair } from 'types/pairs';

import { getProjectFiltersKey } from '../utils';

interface IPayload {
  filter?: IFilterValue;
  dex?: {
    pair?: IDexPair;
    type: EDexPairFilters;
  };
  sol?: {
    pair?: IDexPair;
    type: ESolPairFilters;
  };
  cex?: {
    pair?: ICexPair;
    type: ECexPairFilters;
  };
  general?: EGeneralFilters;
  arbitrage?: EArbitrageFilters;
  project?: {
    projectId: number;
    type: EProjectFilters;
  };
}

export const addFilterReducer: CaseReducer<IFilters, PayloadAction<IPayload>> = (
  state,
  { payload },
) => {
  const { filter, cex, dex, sol, general, arbitrage, project } = payload;

  if (general && state[general]) {
    const newFilters = [...(state[general]!.filters ?? [])];
    newFilters.push(filter ?? { id: uuid() });

    state[general]!.filters = newFilters;

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (arbitrage && state.arbitrage[arbitrage]) {
    const newFilters = [...(state.arbitrage[arbitrage]!.filters ?? [])];
    newFilters.push(filter ?? { id: uuid() });

    state.arbitrage[arbitrage]!.filters = newFilters;

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  if (project) {
    const projectKey = getProjectFiltersKey(project.projectId, project.type);
    const projectEntry = state.project[projectKey];
    if (!projectEntry) return;

    state.project[projectKey] = {
      ...projectEntry,
      updated_at: new Date(Date.now()).toISOString(),
      filters: [...projectEntry.filters, filter ?? { id: uuid() }],
    };

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  const pairId = cex ? cex.pair?.id : dex ? dex.pair?.id : sol ? sol.pair?.id : undefined;
  const type = dex ? dex.type : cex ? cex.type : sol ? sol.type : undefined;
  const key = cex ? 'cex' : dex ? 'dex' : 'sol';

  if (isNil(pairId) || isNil(type) || !state[key][pairId]) return;

  state[key][pairId]!.updated_at = new Date(Date.now()).toISOString();

  //@ts-ignore
  const newFilters = [...(state[key][pairId]!.filters[type]?.filters ?? [])];
  newFilters.push(filter ?? { id: uuid() });

  //@ts-ignore
  state[key][pairId]!.filters[type] = {
    filters: newFilters,
    //@ts-ignore
    setted: state[key][pairId]!.filters[type].setted,
  };

  LocalStorage.set(FILTERS_CACHE_KEY, state);
};
